/*
 * @Author: your name
 * @Date: 2020-12-21 17:31:13
 * @LastEditTime: 2021-01-07 16:00:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\HotpointPlayer.js
 */
import { HotpointSet, Hotpoint } from './Hotpoint'
import { EventEmitter } from 'events/events'
import { CameraController } from './CameraController'
import { CPointSet } from './CameraPoints'
import { Events } from './Events'
import { dirToLonLat } from './Tool/MathTools'
import { waitFor } from './Utils'
import { config } from './config'

export class HotpointPlayer {
  /**
   * 构造函数
   * @param {string[]} setting 配置
   * @param {HotpointSet} hotpointSet 热点集合
   * @param {CameraController} controller 控制器
   * @param {CPointSet} cps 点位集合
   */
  constructor (playIds, hotpointSet, controller, cps) {
    /**
     * @type {string[]} 动画所需播放的热点id数组
     */
    this.animations = playIds
    this.set = hotpointSet
    this.events = new EventEmitter()
    this.ctrl = controller
    this.cps = cps
    this.currIdx = 0

    this.isPlaying = false
    this.isStop = false
  }

  /**
   * 去到某个热点
   * @param {string} id 目标id
   */
  toHotpoint (id) {
    if (this.isPlaying) return
    this.toHotpointAnimation(id)
  }

  /**
   * 播放热点动画
   */
  play () {
    if (this.ctrl.functionLock || this.animations.length === 0 || this.isPlaying) return false
    this.isPlaying = true
    this.isStop = false
    this.autoPlayCallback()
    this.events.emit(Events.HotpointAnimationPlay)
    return true
  }

  /**
   * 停止播放热点动画
   */
  stop () {
    this.isStop = this.isPlaying
  }

  async toHotpointAnimation (id) {
    const hp = this.set.getHotpoint(id)
    if (!hp) throw new Error('No hotpoint id ' + id + ' found')
    const cp = this.findNearest(hp) // this.cps.getCameraPoint(hp.cpointId)
    // todo 寻找最近点位
    if (!cp) throw new Error('Hotpoint was related with a error point id  ' + hp.cpointId)

    if (hp.hpType === 'Jump' || hp.hpType === 'JumpView') return
    const lonLat = dirToLonLat(hp.position.clone().sub(cp.position))

    if (this.ctrl.camera.cameraMode) {
      await this.ctrl.walkThenLookAt(cp.id, lonLat.lon, lonLat.lat)
    } else {
      await this.ctrl.toPano(cp.id)
      await this.ctrl.turn2View(lonLat.lon, lonLat.lat)
    }
    if (hp.interactable && hp.onClick) {
      hp.onClick()
    }
    return hp
  }

  async autoPlayCallback () {
    /**
     * @type {Hotpoint} 即将前往的热点
     */
    let hp = null
    try {
      hp = await this.toHotpointAnimation(this.animations[this.currIdx])
    } catch (e) {
      console.error(e)
      this.isStop = true
    }

    this.currIdx = this.animations.length === 0 ? 0 : (this.currIdx + 1) % this.animations.length
    if (this.checkAndStop()) return
    // 播放热点
    if (hp) {
      let waitTime = config.Hotpoint.AnimationIntervalTime
      await waitFor(waitTime)
      // 等待一段时间，再去获取播放热点所需时间
      waitTime = await hp.getPlayTime() - waitTime
      if (waitTime > 0) {
        // 如果还需等待，继续等一下
        await waitFor(waitTime)
      }
      if (hp.onClose) hp.onClose()
    }

    if (this.checkAndStop()) return
    this.autoPlayCallback()
  }

  checkAndStop () {
    if (this.isStop) {
      this.events.emit(Events.HotpointAnimationStop)
      this.isStop = false
      this.isPlaying = false
      return true
    } else {
      return false
    }
  }

  /**
   *
   * @param {Hotpoint} hp 需要寻找的热点热点
   */
  findNearest (hp) {
    const cDist = config.Hotpoint.MinDist * config.Hotpoint.MinDist

    let minD = Number.MAX_VALUE
    let minCp = null
    for (const cp of this.cps.CameraPoints) {
      const distSq = hp.position.distanceToSquared(cp.position) // 光标与该点位的距离
      if (distSq > cDist && distSq < minD) {
        minD = distSq
        minCp = cp
      }
    }
    return minCp
  }
}
